import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { ContentShell } from "@/components/ContentShell";
import { Seo } from "@/components/Seo";
import { ORDER, ARTICLES } from "@/data/insightsContent";

export default function Insights() {
  const seo = (
    <Seo
      title="Insights — Law firm marketing accountability & ROI | RetainProof"
      description="Practical guides on law firm marketing accountability: how to tell if your marketing is working, how to calculate cost per signed case, marketing attribution, and spotting agency reporting gaps."
      path="/insights"
    />
  );
  return (
    <ContentShell seo={seo} ctaTitle="Ready to see the numbers for your own firm?">
      <section className="max-w-5xl mx-auto px-6 pt-36 pb-10">
        <p className="font-mono-data text-xs uppercase tracking-[0.25em] text-[#D5A44A] mb-5">Insights</p>
        <h1 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl leading-tight tracking-tight max-w-4xl" data-testid="insights-title">
          Marketing accountability, explained for law firm leadership.
        </h1>
        <p className="mt-6 text-lg text-zinc-400 max-w-3xl leading-relaxed">
          Plain-English guides on measuring what your marketing actually produces — from cost per signed case to attribution to spotting the reporting gaps that make vendor performance difficult to verify.
        </p>
      </section>

      <section className="border-t border-white/10 bg-[#0B1F33]">
        <div className="max-w-5xl mx-auto px-6 py-14 grid md:grid-cols-3 gap-6" data-testid="insights-grid">
          {ORDER.map((slug) => {
            const a = ARTICLES[slug];
            return (
              <Link key={slug} to={`/insights/${slug}`} data-testid={`insights-card-${slug}`} className="group border border-white/10 bg-[#12324D] p-7 flex flex-col hover:border-[#D5A44A]/40 transition-colors">
                <p className="font-mono-data text-[10px] uppercase tracking-widest text-zinc-500">{a.read}</p>
                <h2 className="font-display text-xl mt-3 leading-snug text-white group-hover:text-[#D5A44A] transition-colors">{a.title}</h2>
                <p className="mt-3 text-sm text-zinc-400 leading-relaxed flex-1">{a.excerpt}</p>
                <span className="mt-5 inline-flex items-center gap-1.5 text-sm text-[#D5A44A]">Read <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-1" /></span>
              </Link>
            );
          })}
        </div>
      </section>
    </ContentShell>
  );
}
